import React, { useEffect } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogInputAmountControlled from '@/main/components/shared/inputText/inputAmountControlled';
import KogInputTextControlledNew from '@/main/components/shared/inputText/inputTextControlledNew';
import { HeaderSection, HeaderText } from '@/main/components/shared/styles';
import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';

import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import useKogControlElementId from '@/main/hooks/useKogControlElementId';
import { Controls } from '@/main/services/constants/constantsControl';
import { BrandTypeEnum } from '@/main/services/enum/BrandTypeEnum';
import { userIsAdmin } from '@/main/services/utilsUser';
import { getBrand, useBrandReducer } from '@/main/store/brand';

import { IPreQuoteForm, usePreQuoteContext } from '../context';
import { backendForFrontendTire, checkPendingTire } from '../utilsPrequote';
import * as S from './styles';
import TooltipComponent from '@/main/components/shared/tooltip/tooltipComponent';
import RenderTooltipMessage from '@/main/components/shared/renderTooltipMessage/renderTooltipMessage';
import Warning from '@mui/icons-material/Warning';

function SectionTire() {
  const dispatch = useDispatch();
  const CONTROL_TIRE_SECTION = useKogControlElementId(Controls.IdTireSession);
  const [isOpenTooltip, setIsOpenTooltip] = React.useState(false);
  const {
    preQuoteData,
    isLoadingInfoOrder,
  } = usePreQuoteContext();

  const {
    control,
    setValue,
    trigger
  } = useFormContext<IPreQuoteForm>();

  const {
    fields,
    append
  } = useFieldArray<IPreQuoteForm>({
    name: 'tires',
  });

  const { brand: brandReducer } = useBrandReducer();

  function loadTireFields() {
    if (isNullUndefined(preQuoteData) || isNullUndefined(preQuoteData.preQuoteTire)) return;
    const { tires } = backendForFrontendTire(preQuoteData);
    append(tires);
  }

  useEffect(() => {
    if (isNullUndefined(brandReducer.data)) dispatch(getBrand({ idBrandType: BrandTypeEnum.Tire }));
    if (!isLoadingInfoOrder && !isNullUndefined(preQuoteData)) {
      loadTireFields();
    }
  }, [isLoadingInfoOrder, JSON.stringify(preQuoteData)]);

  useEffect(() => {
    if (fields.length > 0) {
      trigger('tires');
    }
  }, [JSON.stringify(fields)]);

  const showTirePending =
    !isNullUndefined(preQuoteData) &&
    checkPendingTire(preQuoteData);

  if (!showTirePending || !CONTROL_TIRE_SECTION) return null;

  return (
    <S.Container>
      <HeaderSection>
        <HeaderText>
          {getTranslateByKey('information.tireInformation')}
        </HeaderText>
      </HeaderSection>
      <S.BodySection>
        {fields.map((field, index) => (
          <S.RowContainer key={field.id}>
              <RenderTooltipMessage
                withClick={!field.notes}
                tooltipMessage={!field.notes && field.partnumber ? field.partnumber : undefined}
              >
                <KogInputTextControlledNew
                  name={`tires.${index}.partnumber`}
                  label={getTranslateByKey('information.PartNumbers')}
                  control={control}
                  disabled
                  required
                  id="id-prequote-txt"
                  InputProps={{
                    endAdornment: field.notes && (
                      <RenderTooltipMessage tooltipMessage={field.partnumber}>
                        <Warning fontSize="small" style={{ color: '#fab01c', cursor: 'pointer', marginLeft: 10 }}
                        />
                      </RenderTooltipMessage>
                    )
                  }}
                />
              </RenderTooltipMessage>
            <KogAutoCompleteControlled
              required
              nameCustom={`tires.${index}.brand`}
              id="id-prequote-select-brand"
              setValueCustom={setValue}
              label={getTranslateByKey('information.brand')}
              control={control}
              rulesCustom={{ required: true }}
              errorMessageCustom=""
              hasErrorCustom={false}
              options={brandReducer.data}
              isLoading={brandReducer.isLoading}
              disabled={false}
              onChangeCustom={() => { }}
            />
            <KogInputTextControlledNew
              required
              name={`tires.${index}.model`}
              label={getTranslateByKey('information.model')}
              control={control}
              id="id-prequote-txt-quoteFilterVehicle"
              onChangeCustom={() => { }}
            />
            <KogInputTextControlledNew
              required
              hasOnlyNumber
              numberOfDecimals={1}
              name={`tires.${index}.width`}
              label={getTranslateByKey('information.width')}
              control={control}
              id="id-prequote-txt-quoteFilterVehicle"
              onChangeCustom={() => { }}
            />
            <KogInputTextControlledNew
              required
              hasOnlyNumber
              numberOfDecimals={1}
              name={`tires.${index}.height`}
              label={getTranslateByKey('information.height')}
              control={control}
              id="id-prequote-txt-quoteFilterVehicle"
              onChangeCustom={() => { }}
            />
            <KogInputTextControlledNew
              required
              name={`tires.${index}.rim`}
              label={getTranslateByKey('information.rim')}
              control={control}
              id="id-prequote-txt-quoteFilterVehicle"
              onChangeCustom={() => { }}
            />
            <KogInputTextControlledNew
              required
              name={`tires.${index}.range`}
              label={getTranslateByKey('information.range')}
              control={control}
              id="id-prequote-txt-quoteFilterVehicle"
              onChangeCustom={() => { }}
            />
            <KogInputAmountControlled
              required={false}
              typeInput={'filled'}
              id="id-createAnswer-txt-answeredPrice"
              name={`tires.${index}.refPrice`}
              disabledMessage={false}
              customInputProps={{
                disabled: false
              }}
              label={getTranslateByKey("information.refPrice")}
              control={control}
              hideValue={false}
              controllerProps={{
              }}
            />
          </S.RowContainer>
        ))}
      </S.BodySection>
    </S.Container>
  )
}

export default SectionTire